export default __webpack_public_path__ + "static/media/learn1.677e5e69.jpg";